import { Dispatch } from "redux";
import Event from 'common/event';
import commoditiesService from "./commodities.service";
import { Currency } from "domain/currency";

export class CurrenciesLoaded extends Event {
	constructor(public currencies: Currency[]) {
		super(CurrenciesLoaded.EventName);
	}

	public static EventName: string = "currencies/loaded";
}

export function loadCurrencies(dispatch: Dispatch): Promise<Currency[]> {
	return commoditiesService
		.listCurrencies()
		.then(data => dispatch(new CurrenciesLoaded(data).toObject()));
}